// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_@rspack+core@1.6.8_@swc+helpers@0.5.17__webpack@5.104.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_@rspack+core@1.6.8_@swc+helpers@0.5.17__webpack@5.104.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mF3umVHMvNQLFZ3k {
  display: inline-block;
}

.mF3umVHMvNQLFZ3k ._ZHQ2t5bkv0FKqle {
  width: 160px;
  text-align: left;
}

.y__65uy8JIdTnQx3 {
  width: 4px !important;
}

.YUUydZdXtgccJl90 {
  width: 100%;
  max-width: 200px;
}

/* Tabs nav divider fallback (antd injects CSS-in-JS after static bundles; !important wins cascade) */
.ZCjClkGbQO_M6nGD.dDCFnoSsTsFfHGW0 > .dV2JyUe10cveP2_h::before,
.ZCjClkGbQO_M6nGD.bKN0BHt7wEucXhEH > .dV2JyUe10cveP2_h::before,
.ZCjClkGbQO_M6nGD.dDCFnoSsTsFfHGW0 > div > .dV2JyUe10cveP2_h::before,
.ZCjClkGbQO_M6nGD.bKN0BHt7wEucXhEH > div > .dV2JyUe10cveP2_h::before {
  border-bottom: 1px solid var(--color-border) !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/styles/antd.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA,qGAAqG;AACrG;;;;EAIE,uDAAuD;AACzD","sourcesContent":[".is-antd-select-container {\n  display: inline-block;\n}\n\n.is-antd-select-container .is-antd-select {\n  width: 160px;\n  text-align: left;\n}\n\n.ant-select-tree-list-scrollbar {\n  width: 4px !important;\n}\n\n.ant-select {\n  width: 100%;\n  max-width: 200px;\n}\n\n/* Tabs nav divider fallback (antd injects CSS-in-JS after static bundles; !important wins cascade) */\n.ant-tabs.ant-tabs-top > .ant-tabs-nav::before,\n.ant-tabs.ant-tabs-bottom > .ant-tabs-nav::before,\n.ant-tabs.ant-tabs-top > div > .ant-tabs-nav::before,\n.ant-tabs.ant-tabs-bottom > div > .ant-tabs-nav::before {\n  border-bottom: 1px solid var(--color-border) !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"is-antd-select-container": `mF3umVHMvNQLFZ3k`,
	"isAntdSelectContainer": `mF3umVHMvNQLFZ3k`,
	"is-antd-select": `_ZHQ2t5bkv0FKqle`,
	"isAntdSelect": `_ZHQ2t5bkv0FKqle`,
	"ant-select-tree-list-scrollbar": `y__65uy8JIdTnQx3`,
	"antSelectTreeListScrollbar": `y__65uy8JIdTnQx3`,
	"ant-select": `YUUydZdXtgccJl90`,
	"antSelect": `YUUydZdXtgccJl90`,
	"ant-tabs": `ZCjClkGbQO_M6nGD`,
	"antTabs": `ZCjClkGbQO_M6nGD`,
	"ant-tabs-top": `dDCFnoSsTsFfHGW0`,
	"antTabsTop": `dDCFnoSsTsFfHGW0`,
	"ant-tabs-nav": `dV2JyUe10cveP2_h`,
	"antTabsNav": `dV2JyUe10cveP2_h`,
	"ant-tabs-bottom": `bKN0BHt7wEucXhEH`,
	"antTabsBottom": `bKN0BHt7wEucXhEH`
};
export default ___CSS_LOADER_EXPORT___;
